import React, { useId } from 'react'; // Import useId

const BridgeBrawlLogo = ({ style, width = "100%", height = "auto" }) => {
  // Generate a unique prefix for this specific instance of the logo
  const idPrefix = useId().replace(/:/g, ""); 
  
  const shieldId = `${idPrefix}-shield`;
  const redGloveId = `${idPrefix}-redGlove`;
  const blackGloveId = `${idPrefix}-blackGlove`;

  return (
    <svg 
        aria-hidden="true" 
        role="img"

        width={width} 
        height={height}
        viewBox="0 0 300 250" 
        xmlns="http://www.w3.org/2000/svg"
        // Force high-quality vector rendering
        shapeRendering="geometricPrecision" 
        textRendering="geometricPrecision"
        style={{
            ...style, 
            transform: 'translateZ(0)', 
            WebkitTransform: 'translateZ(0)'
        }}
    >
      <defs>
        <linearGradient id={shieldId} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#2C3E50" />
          <stop offset="100%" stopColor="#1a1e29" />
        </linearGradient>
        
        <linearGradient id={redGloveId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#E74C3C" />
            <stop offset="100%" stopColor="#7B241C" />
        </linearGradient>
        <linearGradient id={blackGloveId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#5D6D7E" />
            <stop offset="100%" stopColor="#17202A" />
        </linearGradient>
      </defs>

      {/* --- SHIELD --- */}
      {/* UPDATE: Reference the unique ID */}
      <path d="M 50,50 L 250,50 L 250,120 Q 150,240 50,120 Z" fill={`url(#${shieldId})`} stroke="#C0392B" strokeWidth="6" />

      {/* --- CARDS --- */}
      <g transform="translate(150, 30) scale(0.7)">
        <g transform="rotate(-12, 0, 100) translate(-35, 10)">
           <rect x="-25" y="0" width="50" height="70" rx="3" fill="white" stroke="#999" />
           <text x="-15" y="25" fontSize="20" fill="#C0392B" fontWeight="bold">A</text>
           <text x="-15" y="50" fontSize="20" fill="#C0392B">♥️</text>
        </g>
        <g transform="rotate(-4, 0, 100) translate(-12, 2)">
           <rect x="-25" y="0" width="50" height="70" rx="3" fill="white" stroke="#999" />
           <text x="-15" y="25" fontSize="20" fill="black" fontWeight="bold">A</text>
           <text x="-15" y="50" fontSize="20" fill="black">♠️</text>
        </g>
        <g transform="rotate(4, 0, 100) translate(12, 2)">
           <rect x="-25" y="0" width="50" height="70" rx="3" fill="white" stroke="#999" />
           <text x="-15" y="25" fontSize="20" fill="#C0392B" fontWeight="bold">A</text>
           <text x="-15" y="50" fontSize="20" fill="#C0392B">♦️</text>
        </g>
        <g transform="rotate(12, 0, 100) translate(35, 10)">
           <rect x="-25" y="0" width="50" height="70" rx="3" fill="white" stroke="#999" />
           <text x="-15" y="25" fontSize="20" fill="black" fontWeight="bold">A</text>
           <text x="-15" y="50" fontSize="20" fill="black">♣️</text>
        </g>
      </g>
      
      {/* --- GLOVES --- */}
      <g transform="translate(63, 110) rotate(-35) scale(0.7, -0.7)">
          <path d="M0,20 L25,18 L28,52 L0,50 Z" fill="#641E16" stroke="#501510" strokeWidth="1" />
          {/* UPDATE: Reference the unique ID */}
          <path d="M25,18 Q40,0 65,5 Q85,10 80,35 Q78,55 60,55 Q40,55 28,52" fill={`url(#${redGloveId})`} stroke="#501510" strokeWidth="2" strokeLinejoin="round" />
          <path d="M30,35 Q30,20 55,25 Q60,30 55,35" fill="#C0392B" stroke="#501510" strokeWidth="2" strokeLinejoin="round" />
      </g>
      
      <g transform="translate(237, 110) rotate(35) scale(-0.7, -0.7)">
          <path d="M0,20 L25,18 L28,52 L0,50 Z" fill="#1B2631" stroke="#000" strokeWidth="1" />
          {/* UPDATE: Reference the unique ID */}
          <path d="M25,18 Q40,0 65,5 Q85,10 80,35 Q78,55 60,55 Q40,55 28,52" fill={`url(#${blackGloveId})`} stroke="#000" strokeWidth="2" strokeLinejoin="round" />
          <path d="M30,35 Q30,20 55,25 Q60,30 55,35" fill="#34495E" stroke="#000" strokeWidth="2" strokeLinejoin="round" />
      </g>
      
      {/* --- TEXT --- */}
      <text x="150" y="130" textAnchor="middle" fontSize="42" fontWeight="900" fontFamily="Arial, sans-serif" fill="#FFD700" stroke="black" strokeWidth="1.5">
        BRIDGE
      </text>
      <text x="150" y="165" textAnchor="middle" fontSize="42" fontWeight="900" fontFamily="Arial, sans-serif" fill="#FFD700" stroke="black" strokeWidth="1.5">
        BRAWL
      </text>
      <text x="150" y="195" textAnchor="middle" fontSize="20" fontWeight="bold" fontFamily="Arial, sans-serif" fill="#FFD700" letterSpacing="3">
        2026
      </text>
    </svg>
  );
};
export default BridgeBrawlLogo;